import script from "./ThreeBlockRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./ThreeBlockRow.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__